export const getters = {
  getBoards: state => state.boards,
  getTasks: state => state.tasks,
  tasksForColumn: state => columnId =>
    state.tasks
      .filter(t => t.column_id === columnId)
      .sort((a, b) => a.position - b.position),
};
